<template>
    <b-modal ref="modal" size="lg" id="modal-file" hide-footer title="Enviar arquivo">
        <ValidationObserver v-slot="{ handleSubmit }" slim ref="observer">
            <form action="#" method="post" @submit.prevent="handleSubmit(onSubmit)">
                <b-row v-for="(anexo, index) in anexos" :key="anexo.produto_anexo_id">
                    <b-col>
                        <ValidationProvider :name="`'${anexo.descricao}'`" :rules="{ required: anexo.obrigatorio, size: anexo.tamanho_maximo / 1024 }" slim v-slot="{ errors, classes, required}">
                            <div class="form-group">
                                <label :for="`file${index}`" v-html="anexo.descricao"></label>
                                <fileUpload v-model="anexo.file" @input="handleFileUpload(anexo, $event)" @remove="removeFile(anexo, $event)" :accept="anexo.formatos_aceitos" :inputclass="anexo.cssclass" :progress="progress"></fileUpload>
                                <small v-show="errors[0]" class="text-danger text-left">{{ errors[0] }}</small>
                                <small class="d-block">Tamanho máximo do arquivo {{ anexo.tamanho_maximo / 1024 / 1024 }}MB</small>
                            </div>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <div class="file__rule">
                            <div v-if="error_msg" class="error-alert" v-html="error_msg"></div>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="d-flex justify-content-end mt-2">
                            <button type="submit" class="btn-default btn-square pr-5 pl-5" :disabled="sending">
                                {{ sending ? 'Enviando' : 'Salvar' }}
                            </button>
                        </div>
                    </b-col>
                </b-row>
            </form>
        </ValidationObserver>
    </b-modal>
</template>

<script>
    import {ValidationProvider, ValidationObserver} from "vee-validate";
    import FileUpload from "~/components/inputs/fileUpload";

    export default {
        components: {
            FileUpload,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            product: {
                type: Object,
                default: () => {}
            }
        },
        data: function () {
            return {
                error_msg: '',
                sending: false,
                progress: 0,
                files: {},
                anexos: []
            }
        },
        mounted() {
            this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
                if (modalId === 'modal-file') {
                    if (typeof this.product === 'object' && typeof this.product.anexos === 'object') {
                        this.anexos = []
                        this.product.anexos.forEach(item => {
                            let el = Object.assign({}, item)
                            this.$set(el, 'cssclass', el.arquivo ? 'is-valid' : '')
                            if (el.nome) {
                                el['file'] = {
                                    name: el.nome,
                                    uploading: false
                                }
                            }
                            this.anexos.push(el)
                        })
                    }
                }
            })
        },
        methods: {
            handleFileUpload(anexo, $event) {
                this.files[anexo.produto_anexo_id] = {
                    attachment: anexo,
                    file: $event
                }
            },
            async onSubmit() {
                for (let index in this.files) {
                    this.uploadFile(this.files[index].attachment, this.files[index].file);
                }
            },
            async uploadFile(anexo, file) {
                let params = new FormData();
                params.append('product_order_id', this.product.id);
                params.append('product_attachment_id', anexo.produto_anexo_id);
                params.append('file', file);
                this.$axios.setHeader('Content-Type', 'multipart/form-data', [
                    'post'
                ]);
                this.$axios.$post('?p=ecommerce_pedidos_api_v1&metodo=add_attachament', params, {
                    onUploadProgress: (event) => {
                        this.progress = Math.round((event.loaded * 100) / event.total)
                        if (this.progress === 100) {
                            setTimeout(() => {
                                this.progress = 0
                            }, 1000)
                        }
                    }
                })
                    .then((response) => {
                        if (response.msg === 'sucesso') {
                            anexo.nome = file.name
                            this.error_msg = ''
                            this.$root.$emit('updatedCart')
                            this.$set(anexo, 'cssclass', 'is-valid')
                            // $('#modal-file').modal('hide');
                            this.$refs['modal'].hide()
                            this.$store.dispatch('order/loadOrder')
                        } else {
                            this.error_msg = response.msg_completa
                            this.$set(anexo, 'cssclass', 'is-invalid')
                        }
                        this.sending = false;
                    })
                    .catch(e => {
                        this.error_msg = 'Não foi possível enviar!'
                        this.$set(anexo, 'cssclass', 'is-invalid')
                        this.sending = false;
                    })
            },
            async removeFile(anexo) {
                anexo.file = {}
                let params = new FormData();
                params.append('product_order_id', this.product.id);
                params.append('product_attachment_id', anexo.produto_anexo_id);
                this.$axios.$post('?p=ecommerce_pedidos_api_v1&metodo=remove_attachament', params)
                    .then((response) => {
                        if (response.msg === 'sucesso') {
                            this.error_msg = ''
                            this.progress = 0
                            this.$set(anexo, 'cssclass', '')
                            this.$root.$emit('updatedCart')
                            this.$store.dispatch('order/loadOrder')
                        } else {
                            this.error_msg = response.msg_completa
                        }
                        this.$set(anexo, 'file', {name: ''})
                        this.files[anexo.produto_anexo_id] = {
                            attachment: {},
                            file: {}
                        }
                        anexo.cssclass = ''
                        this.sending = false
                        this.$refs.observer.reset()
                        this.error_msg = ''
                    })
                    .catch(e => {
                        this.error_msg = 'Não foi possível enviar!'
                        this.sending = false;
                    })
            }
        }
    };
</script>
